import { apiService } from "./../../app.service";

export const deliveryApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new supplier
    createSupplier: builder.mutation({
      query: (data) => ({
        url: "/user/supplier/create",
        method: "POST",
        body: data,
      }),
    }),

    // Get all suppliers
    fetchSuppliersList: builder.query({
      query: () => ({
        url: "/user/supplier/getAll",
        method: "GET",
      }),
    }),
    createDelivery: builder.mutation({
      query: (data) => ({
        url: "/user/delivery/create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["deliveries"],
    }),

    // Get all suppliers
    fetchDeliveriesList: builder.query({
      query: () => ({
        url: "/user/delivery/getAll",
        method: "GET",
      }),
      providesTags: ["deliveries"],
    }),

    updateDeliveryComment: builder.mutation({
      query: ({ id, comment }) => ({
        url: `/user/delivery/${id}/comment`,
        method: "PATCH",
        body: { comment },
      }),
      invalidatesTags: ["deliveries"],
    }),
  }),
});

export const {
  useCreateSupplierMutation,
  useFetchSuppliersListQuery,
  useCreateDeliveryMutation,
  useFetchDeliveriesListQuery,
  useUpdateDeliveryCommentMutation,
} = deliveryApi;
